import { createSharedComposable } from '@vueuse/core';

var en = {
	services: {
		storybook: {
			label: "Storybook"
		},
		softphone: {
			label: "Soft Phone"
		},
		aiassist: {
			label: "AI Assist"
		},
		problem_helper: {
			label: "Report a problem"
		}
	},
	components: {
		emojipicker: {
			label: "Emoji Picker"
		}
	},
	notifications: {
		Notifications: "Notifications",
		"Trail events": "Trail events",
		"Mark all as read": "Mark all as read",
		"No notifications yet": "No notifications yet",
		"There is no new notifications for you": "There is no new notifications for you."
	},
	serviceDropdown: {
		label: "Services",
		"No results": "No results",
		results: "results",
		no_found_first_line: "We couldn’t find any results for this search.",
		not_found_second_line: "Please update your search criteria.",
		"Edit mode": "Edit mode",
		"Hide from account": "Hide from account",
		"Hide from environment": "Hide from environment",
		Filters: "Filters",
		Delete: "Delete",
		"Show in account": "Show in account",
		"Show in environment": "Show in environment",
		Visible: "Visible",
		"Hidden from account": "Hidden from account",
		"Hidden from environment": "Hidden from environment"
	},
	deleteConfirmation: {
		title: "Delete service",
		message_before: "Are you sure you want to delete",
		message_after: "service permanently? This action cannot be undone."
	},
	deleteToastMessage: "<span class='typography-caption-bold'>{service}</span> service has been deleted from environment.",
	hideEnvironmentToastMessage: "<span class='typography-caption-bold'>{service}</span> service has been hidden from environment.",
	hideAccountToastMessage: "<span class='typography-caption-bold'>{service}</span> service has been hidden from account.",
	idw: "IDW"
};
var DEFAULT_TRANSLATIONS = {
	en: en
};

function useI18n() {
  let $i18n;
  return {
    initializeI18n(instance) {
      var _a;
      if (!instance) {
        console.error('"initializeI18n" must be called within a setup function');
      }
      $i18n = (_a = instance === null || instance === void 0 ? void 0 : instance.proxy) === null || _a === void 0 ? void 0 : _a.$i18n;
      $i18n.mergeLocaleMessage($i18n.locale, DEFAULT_TRANSLATIONS.en);
    },
    mergeLocaleMessages(messages) {
      for (const locale in messages) {
        $i18n.mergeLocaleMessage(locale, messages[locale]);
      }
    },
    t(str, ...args) {
      return $i18n.t(str, ...args);
    }
  };
}
var useI18n$1 = createSharedComposable(useI18n);

export { useI18n$1 as u };
